/** Camera cloud auth – GStorage token for cloud recording media access. */

import type { GStorageSignedUrlResponse } from 'src/components/Camera/types/cloud-recordings';
import { get, writable } from 'svelte/store';

const STORAGE_KEY = 'camera_cloud_auth';

const defaultState = { token: null as string | null, expiresAt: null as string | null };

function create_camera_cloud_auth() {
	const { subscribe, set } = writable(
		JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null') || defaultState,
	);

	return {
		subscribe,
		set,
		get,
		setFromResponse: (response: GStorageSignedUrlResponse) => {
			const expiresAt = response.expiresIn
				? new Date(Date.now() + response.expiresIn * 1000).toISOString()
				: null;
			set({ token: response.token, expiresAt });
		},
		clear: () => set(defaultState),
	};
}

export const camera_cloud_auth = create_camera_cloud_auth();
camera_cloud_auth.subscribe((val) => localStorage.setItem(STORAGE_KEY, JSON.stringify(val)));
